function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { FormControl, FormLabel, FormControlLabel, Radio, RadioGroup, Typography, makeStyles } from '@applyboard/ui-components';
import { connect } from 'react-redux';
import { Keys, EDUCATION_STATUS_KEYS } from "../Constants";
import { setField } from "../../../../store/Actions/Actions";
import { getApplication } from "../../../../store/Selectors";
import LabelWrapper from "../LabelWrapper";
import ErrorMessage from "../ErrorMessage";
import { getEducationStatusLabel } from "../../Utilities/LanguageHelper";
var useStyles = makeStyles({
  formControlLabel: {
    paddingRight: '3vw',
    '&.MuiFormControlLabel-root': {
      margin: '0 0 0 -8px'
    }
  }
});
var EducationStatusComponent = function EducationStatusComponent(props) {
  var keyName = props.keyName,
    educationStatus = props.educationStatus,
    isMobile = props.isMobile,
    errorMessage = props.errorMessage,
    clearError = props.clearError;
  var classes = useStyles();
  var handleChange = function handleChange(event) {
    var dto = {
      key: Keys.Application.educationStatus,
      value: event.target.value
    };
    props.setField(dto);
    clearError(keyName);
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(FormLabel, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption"
  }, "Status")), /*#__PURE__*/React.createElement(RadioGroup, {
    "aria-label": "".concat(Keys.Application.educationStatus, " radio group"),
    name: Keys.Application.educationStatus,
    value: educationStatus,
    onChange: handleChange,
    row: !isMobile
  }, EDUCATION_STATUS_KEYS.map(function (es) {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      className: classes.formControlLabel,
      "aria-label": "".concat(es, " radio button"),
      key: es,
      value: es,
      control: /*#__PURE__*/React.createElement(Radio, null),
      label: /*#__PURE__*/React.createElement(LabelWrapper, null, getEducationStatusLabel(es))
    });
  })), /*#__PURE__*/React.createElement("div", null, errorMessage && /*#__PURE__*/React.createElement(ErrorMessage, {
    message: errorMessage
  })));
};
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var application = getApplication(state);
  return _defineProperty({
    isMobile: ownProps.isMobile
  }, Keys.Application.educationStatus, application.educationStatus);
};
export default connect(mapStateToProps, {
  setField: setField
})(EducationStatusComponent);